/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  // if ($(window).width() > 640) {
  //   $(".collapse-pc").addClass("in");
  // } else {
  //   $(".collapse-pc").removeClass("in");
  // }
});
